import React from 'react';
import {SvgIcon} from '@material-ui/core';
// import LifeRingSvg from '../../assets/lifeRing.svg';
import AnchorPng from '../../assets/anchor.png';
import AnchorFilledIcon from 'components/icons/Anchor';
import DocumentPng from '../../assets/document-icon-sm-2.png';
import LogoTextSvg from '../../assets/MM-Seas-LogoReversed.svg';
import LogoTextWhiteJpg from '../../assets/LogoTextWhite.jpg';
import AddButtonPng from '../../assets/Add_Button.png';
import UserIcon from '../../assets/userIcon.png';
import LogoPng from '../../assets/MM-Logo.png';
import SignInIcon from '../../assets/Sign_in.png';
import CreateAccountIcon from 'assets/Create_an_Account.png';
import TugValorSvg from '../../assets/tugvalor.svg';
import BillOfRightsSvg from '../../assets/BillofRights.svg';
import PersonSearchSvg from '../../assets/account-search.svg';
import PersonSearchLightSvg from '../../assets/person-search-light.svg';
import BillingInfoPlaceholderPng from 'assets/billing-info-placeholder.png';
import MMSEASLogoTransparentPng from 'assets/MM-Seas-Logo-transparent.png';
import MMSEASLogoReversedPng from 'assets/MM-Seas-LogoReversed-noTM.png';
import {ReactComponent as CircleSvg} from 'assets/circle.svg';
import CircleInfoPopoutSvg from 'components/icons/Info';
import {ReactComponent as PartyHatSvg} from 'assets/partyHat.svg';
import {ReactComponent as SuccessSvg} from 'assets/success.svg';
import {ReactComponent as ErrorSvg} from 'assets/error.svg';
import {ReactComponent as CloudErrorSvg} from 'assets/cloud-error.svg';
import {ReactComponent as LockedSvg} from 'assets/locked.svg';
import {ReactComponent as CloudLockedSvg} from 'assets/cloud_locked.svg';
import MMCLookupPng from '../../assets/MMC-Lookup-Widget.png';
import DeleteDocumentPng from '../../assets/Delete-Document-Button.png';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    svg: {
        fill: theme.palette.text.primary,
        '& svg': {
            fill: theme.palette.text.primary,
        },
    },
}));

const fallbackToUnit = unit => string => {
    if (
        isNaN(parseInt(string)) ||
        `${string}`.endsWith('%') ||
        `${string}`.endsWith('em')
    ) {
        return string;
    } else {
        return `${string}${unit}`;
    }
};

function BaseIcon(props) {
    const ensurePx = fallbackToUnit('px');

    const width = ensurePx(props.width);
    const maxWidth = ensurePx(props.maxWidth);
    const height = ensurePx(props.height);
    const maxHeight = ensurePx(props.maxHeight);
    const source = props.source;

    return (
        <img
            style={{
                width,
                height,
                maxWidth,
                maxHeight,
            }}
            {...props}
            alt={props.alt}
            src={source}
        />
    );
}

function Anchor(props) {
    return <BaseIcon source={AnchorPng} alt='' {...props} />;
}
function AnchorGray(props) {
    return <AnchorFilledIcon alt='' {...props} />;
}

function Document(props) {
    return <BaseIcon source={DocumentPng} alt='' {...props} />;
}

function PersonSearch(props) {
    return <BaseIcon source={PersonSearchSvg} alt='' {...props} />;
}

function PersonSearchLight(props) {
    return <BaseIcon source={PersonSearchLightSvg} alt='' {...props} />;
}

function LogoText(props) {
    return <BaseIcon source={LogoTextSvg} alt='' {...props} />;
}

function LogoTextWhite(props) {
    return <BaseIcon source={LogoTextWhiteJpg} alt='' {...props} />;
}

function Logo(props) {
    return <BaseIcon source={LogoPng} alt='' {...props} />;
}

function AddButton(props) {
    return <BaseIcon source={AddButtonPng} alt='' {...props} />;
}

function User(props) {
    return <BaseIcon source={UserIcon} alt='' {...props} />;
}

function SignIn(props) {
    return <BaseIcon source={SignInIcon} alt='' {...props} />;
}

function CreateAccount(props) {
    return <BaseIcon source={CreateAccountIcon} alt='' {...props} />;
}

function LifeRing(props) {
    // return <BaseIcon source={lifeRing} alt='LifeRing Icon' {...props} />;
    return (
        <SvgIcon {...props}>
            <path d='M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M19.46,9.12l-2.78,1.15 c-0.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78C16.98,5.35,18.65,7.02,19.46,9.12z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 S13.66,15,12,15z M9.13,4.54l1.17,2.78c-1.38,0.5-2.47,1.59-2.98,2.97L4.54,9.13C5.35,7.02,7.02,5.35,9.13,4.54z M4.54,14.87 l2.78-1.15c0.51,1.38,1.59,2.46,2.97,2.96l-1.17,2.78C7.02,18.65,5.35,16.98,4.54,14.87z M14.88,19.46l-1.15-2.78 c1.37-0.51,2.45-1.59,2.95-2.97l2.78,1.17C18.65,16.98,16.98,18.65,14.88,19.46z' />
        </SvgIcon>
    );
}

function TugValor(props) {
    return <BaseIcon source={TugValorSvg} alt='' {...props} />;
}

function BillOfRights(props) {
    return <BaseIcon source={BillOfRightsSvg} alt='' {...props} />;
}

function BillingInfoPlaceholder(props) {
    return <BaseIcon source={BillingInfoPlaceholderPng} alt='' {...props} />;
}

function Circle(props) {
    return <CircleSvg alt='' {...props} />;
}

function CircleInfoPopout(props) {
    const classes = useStyles();
    return <CircleInfoPopoutSvg alt='' className={classes.svg} {...props} />;
}

function MMSEASLogoTransparent(props) {
    return <BaseIcon source={MMSEASLogoTransparentPng} alt='' {...props} />;
}

function MMSEASLogoReversed(props) {
    return <BaseIcon source={MMSEASLogoReversedPng} alt='' {...props} />;
}

const PartyHatIcon = props => {
    return <PartyHatSvg alt='' {...props} />;
};

const SuccessIcon = props => {
    require('assets/successerror.css');
    return <SuccessSvg alt='' height='100px' width='100px' {...props} />;
};

const ErrorIcon = props => {
    require('assets/successerror.css');
    return <ErrorSvg alt='' height='100px' width='100px' {...props} />;
};

const CloudErrorIcon = props => {
    return <CloudErrorSvg alt='' height='100px' width='100px' {...props} />;
};
const LockedIcon = props => {
    return <LockedSvg alt='' height='100px' width='100px' {...props} />;
};
const CloudLockedIcon = props => {
    return <CloudLockedSvg alt='' height='100px' width='100px' {...props} />;
};

const MMCLookupPicture = props => {
    return <BaseIcon source={MMCLookupPng} alt='' {...props} />;
};

const DeleteDocumentPicture = props => {
    return <BaseIcon source={DeleteDocumentPng} alt='' {...props} />;
};

export {
    LifeRing,
    Anchor,
    AnchorGray,
    BillingInfoPlaceholder,
    Document,
    LogoText,
    AddButton,
    User,
    Logo,
    SignIn,
    CreateAccount,
    TugValor,
    BillOfRights,
    PersonSearch,
    PersonSearchLight,
    LogoTextWhite,
    Circle,
    CircleInfoPopout,
    MMSEASLogoTransparent,
    PartyHatIcon,
    SuccessIcon,
    ErrorIcon,
    CloudErrorIcon,
    LockedIcon,
    CloudLockedIcon,
    MMCLookupPicture,
    DeleteDocumentPicture,
    MMSEASLogoReversed,
};
